/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BatchGetResponseFeedbackRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  batchGetFeedbackRequest: components.BatchGetFeedbackRequest;
};

/** @internal */
export const BatchGetResponseFeedbackRequest$inboundSchema: z.ZodType<
  BatchGetResponseFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  BatchGetFeedbackRequest: components.BatchGetFeedbackRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "BatchGetFeedbackRequest": "batchGetFeedbackRequest",
  });
});
/** @internal */
export type BatchGetResponseFeedbackRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  BatchGetFeedbackRequest: components.BatchGetFeedbackRequest$Outbound;
};

/** @internal */
export const BatchGetResponseFeedbackRequest$outboundSchema: z.ZodType<
  BatchGetResponseFeedbackRequest$Outbound,
  z.ZodTypeDef,
  BatchGetResponseFeedbackRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  batchGetFeedbackRequest: components.BatchGetFeedbackRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    batchGetFeedbackRequest: "BatchGetFeedbackRequest",
  });
});

export function batchGetResponseFeedbackRequestToJSON(
  batchGetResponseFeedbackRequest: BatchGetResponseFeedbackRequest,
): string {
  return JSON.stringify(
    BatchGetResponseFeedbackRequest$outboundSchema.parse(
      batchGetResponseFeedbackRequest,
    ),
  );
}
export function batchGetResponseFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<BatchGetResponseFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BatchGetResponseFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BatchGetResponseFeedbackRequest' from JSON`,
  );
}
